import { createSelector } from "reselect"
import { get, chain, pick } from "lodash"
import { buildContributorKey } from "helpers/contributors"
import { computeAttributionMethod } from "helpers/risk"
import { getIsActiveAndNotIntraday } from "../intraday"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

export const getRiskSummary = state => get(state, "global.data.risk.data.model.simulation.risk.0", EMPTY_OBJECT)
export const getRebalancedRiskSummary = state => get(state, "modules.rebalance.rebalancedRisk", EMPTY_OBJECT)

// Contributors
const getRawContributors = state => get(state, "global.data.riskContributors.data.model.simulation.riskContributors", EMPTY_ARRAY)
const getRebalancedContributors = state => get(state, "modules.rebalance.rebalancedRiskContributors", EMPTY_ARRAY)

// Grouped Contributors
const getRawGroupedContributors = state => get(state, "global.data.groupedRiskContributors.data.model.simulation.groupedRiskContributors", EMPTY_ARRAY)
const getGroupedRebalancedContributors = state => get(state, "modules.rebalance.rebalancedGroupedRiskContributors", EMPTY_ARRAY)

export const getRiskContributors = createSelector(
  [getRawContributors],
  computeRiskContributors,
)

export const getGroupedRiskContributors = createSelector(
  [getRawGroupedContributors],
  computeRiskContributors,
)

export const getRebalancedRiskContributors = createSelector(
  [getRebalancedContributors],
  computeRiskContributors,
)

export const getGroupedRebalancedRiskContributors = createSelector(
  [getGroupedRebalancedContributors],
  computeRiskContributors,
)

function computeRiskContributors(contributors) {
  return chain(contributors)
    .keyBy(buildContributorKey)
    .mapValues((contributor) => ({
      ...pick(contributor, ["id", "modelProviderId", "assetClass", "description"]),
      summary: {
        total: get(contributor, "attribution.summary.factors") + get(contributor, "attribution.summary.specific"),
        factors: get(contributor, "attribution.summary.factors"),
        specific: get(contributor, "attribution.summary.specific"),
      },
      ...(contributor.contributors && { contributors: computeRiskContributors(contributor.contributors) }),
    }))
    .value()
}

export const getAttributionMethod = createSelector(
  [getIsActiveAndNotIntraday],
  computeAttributionMethod,
)
